var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDeactivateAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    viewBox: "0 0 45 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1667 35.7497V31.8608C30.1667 29.798 29.3472 27.8197 27.8886 26.3611C26.43 24.9025 24.4517 24.083 22.3889 24.083H8.77778C6.71498 24.083 4.73667 24.9025 3.27806 26.3611C1.81944 27.8197 1 29.798 1 31.8608V35.7497",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 16.3056C19.879 16.3056 23.3612 12.8233 23.3612 8.52778C23.3612 4.23223 19.879 0.75 15.5834 0.75C11.2879 0.75 7.80566 4.23223 7.80566 8.52778C7.80566 12.8233 11.2879 16.3056 15.5834 16.3056Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0557 10.4727L43.7779 20.1949",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7779 10.4727L34.0557 20.1949",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDeactivateAccount);
export default __webpack_public_path__ + "static/media/icn-deactivate-account.c65fe92ccd1e6dd40cf4751d8cfc0e2d.svg";
export { ForwardRef as ReactComponent };